import React from 'react';
import { Spinner, SpinnerSize, SpinnerVariant } from '@cmhc-schl/hearth-ui';
import { Box } from '@mui/material';

interface SpinnerSectionProps {
  loading: boolean;
  children: React.ReactNode;
}

const SpinnerSection = ({ loading, children }: SpinnerSectionProps) => {
  return loading ? <SpinnerFullWidth /> : <>{children}</>;
};

const SpinnerFullWidth = () => (
  <Box display="flex" justifyContent="center" paddingTop="64px" paddingBottom="64px" width="100%">
    <Spinner size={SpinnerSize.LARGE} type={SpinnerVariant.PRIMARY} />
  </Box>
);

export default SpinnerSection;
